import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
import { getIntDictOptions, getBoolDictOptions, DICT_TYPE } from '@/utils/dict';
import { ChatRoleApi } from '@/api/ai/model/chatRole';
import { CommonStatusEnum } from '@/utils/constants';
import { ModelApi } from '@/api/ai/model/model';
import { AiModelTypeEnum } from '@/constants/ai-constants';
import { KnowledgeApi } from '@/api/ai/knowledge/knowledge';
import { ToolApi } from '@/api/ai/model/tool';
import { useMessage } from '@/hooks/web/useMessage';
import { computed, reactive, ref } from 'vue';
/** AI 聊天角色 表单 */
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'ChatRoleForm'
  },
  __name: 'ChatAppsEditDialog',
  emits: ['success'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const message = useMessage(); // 消息弹窗
    const dialogVisible = ref(false); // 弹窗的是否展示
    const dialogTitle = ref(''); // 弹窗的标题
    const formLoading = ref(false); // 表单的加载中：1）修改时的数据加载；2）提交的按钮禁用
    const formType = ref(''); // 表单的类型：create - 新增；update - 修改
    const formData = ref({
      id: undefined,
      modelId: undefined,
      name: undefined,
      avatar: undefined,
      category: undefined,
      sort: undefined,
      description: undefined,
      systemMessage: undefined,
      publicStatus: true,
      status: CommonStatusEnum.ENABLE,
      knowledgeIds: [],
      toolIds: []
    });
    const formRef = ref(); // 表单 Ref
    const models = ref([]); // 聊天模型列表
    const knowledgeList = ref([]); // 知识库列表
    const toolList = ref([]); // 工具列表
    /** 是否【我】自己创建，私有角色 */
    const isUser = computed(() => {
      return formType.value === 'my-create' || formType.value === 'my-update';
    });
    const formRules = reactive({
      name: [{
        required: true,
        message: '角色名称不能为空',
        trigger: 'blur'
      }],
      avatar: [{
        required: true,
        message: '角色头像不能为空',
        trigger: 'blur'
      }],
      category: [{
        required: true,
        message: '角色类别不能为空',
        trigger: 'blur'
      }],
      sort: [{
        required: true,
        message: '角色排序不能为空',
        trigger: 'blur'
      }],
      description: [{
        required: true,
        message: '角色描述不能为空',
        trigger: 'blur'
      }],
      systemMessage: [{
        required: true,
        message: '角色设定不能为空',
        trigger: 'blur'
      }],
      publicStatus: [{
        required: true,
        message: '是否公开不能为空',
        trigger: 'blur'
      }]
    });
    /** 打开弹窗 */
    // TODO @fan：title 是不是收敛到 type 判断生成 title，会更合理
    const open = async (type, id, title) => {
      dialogVisible.value = true;
      dialogTitle.value = title || '新增应用';
      formType.value = type;
      resetForm();
      // 修改时，设置数据
      if (id) {
        formLoading.value = true;
        try {
          formData.value = await ChatRoleApi.getChatRole(id);
        } finally {
          formLoading.value = false;
        }
      }
      // 获得下拉数据
      models.value = await ModelApi.getModelSimpleList(AiModelTypeEnum.CHAT);
      // 获取知识库列表
      knowledgeList.value = await KnowledgeApi.getSimpleKnowledgeList();
      // 获取工具列表
      toolList.value = await ToolApi.getToolSimpleList();
    };
    __expose({
      open
    }); // 提供 open 方法，用于打开弹窗
    /** 提交表单 */
    const emit = __emit; // 定义 success 事件，用于操作成功后的回调
    const submitForm = async () => {
      // 校验表单
      await formRef.value.validate();
      // 提交请求
      formLoading.value = true;
      try {
        const data = formData.value;
        // tip: my-create、my-update 是 chat 角色仓库调用
        // tip: create、else 是后台管理调用
        if (formType.value === 'my-create') {
          await ChatRoleApi.createMy(data);
          message.success('创建成功');
        } else if (formType.value === 'my-update') {
          await ChatRoleApi.updateMy(data);
          message.success('修改成功');
        } else if (formType.value === 'create') {
          await ChatRoleApi.createChatRole(data);
          message.success('创建成功');
        } else {
          await ChatRoleApi.updateChatRole(data);
          message.success('修改成功');
        }
        dialogVisible.value = false;
        // 发送操作成功的事件
        emit('success');
      } finally {
        formLoading.value = false;
      }
    };
    /** 重置表单 */
    const resetForm = () => {
      formData.value = {
        id: undefined,
        modelId: undefined,
        name: undefined,
        avatar: undefined,
        category: undefined,
        sort: undefined,
        description: undefined,
        systemMessage: undefined,
        publicStatus: true,
        status: CommonStatusEnum.ENABLE,
        knowledgeIds: [],
        toolIds: []
      };
      formRef.value?.resetFields();
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_UploadImg = _resolveComponent("UploadImg");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_Dialog = _resolveComponent("Dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_Dialog, {
        title: dialogTitle.value,
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => dialogVisible.value = $event)
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: submitForm,
          type: "primary",
          disabled: formLoading.value
        }, {
          default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("确 定")])),
          _: 1
        }, 8, ["disabled"]), _createVNode(_component_el_button, {
          onClick: _cache[11] || (_cache[11] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("取 消")])),
          _: 1
        })]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: formData.value,
          rules: formRules,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "角色名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value.name = $event),
              placeholder: "请输入角色名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "角色头像",
            prop: "avatar"
          }, {
            default: _withCtx(() => [_createVNode(_component_UploadImg, {
              modelValue: formData.value.avatar,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value.avatar = $event),
              height: "60px",
              width: "60px"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), !isUser.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "绑定模型",
            prop: "modelId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.value.modelId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.value.modelId = $event),
              placeholder: "请选择模型",
              clearable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(models.value, model => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: model.id,
                  label: model.name,
                  value: model.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), !isUser.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "角色类别",
            prop: "category"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.category,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.value.category = $event),
              placeholder: "请输入角色类别"
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "角色描述",
            prop: "description"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              modelValue: formData.value.description,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.value.description = $event),
              placeholder: "请输入角色描述"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "角色设定",
            prop: "systemMessage"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              modelValue: formData.value.systemMessage,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formData.value.systemMessage = $event),
              placeholder: "请输入角色设定"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "引用知识库",
            prop: "knowledgeIds"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.value.knowledgeIds,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => formData.value.knowledgeIds = $event),
              placeholder: "请选择知识库",
              clearable: "",
              multiple: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(knowledgeList.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "引用工具",
            prop: "toolIds"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.value.toolIds,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => formData.value.toolIds = $event),
              placeholder: "请选择工具",
              clearable: "",
              multiple: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toolList.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), !isUser.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 2,
            label: "是否公开",
            prop: "publicStatus"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: formData.value.publicStatus,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => formData.value.publicStatus = $event)
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getBoolDictOptions)(_unref(DICT_TYPE).INFRA_BOOLEAN_STRING), (dict, index) => {
                return _openBlock(), _createBlock(_component_el_radio, {
                  key: index,
                  value: dict.value
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(dict.label), 1)]),
                  _: 2
                }, 1032, ["value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), !isUser.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 3,
            label: "角色排序",
            prop: "sort"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: formData.value.sort,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => formData.value.sort = $event),
              placeholder: "请输入角色排序",
              class: "!w-1/1"
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), !isUser.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 4,
            label: "开启状态",
            prop: "status"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: formData.value.status,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => formData.value.status = $event)
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getIntDictOptions)(_unref(DICT_TYPE).COMMON_STATUS), dict => {
                return _openBlock(), _createBlock(_component_el_radio, {
                  key: dict.value,
                  value: dict.value
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(dict.label), 1)]),
                  _: 2
                }, 1032, ["value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model", "rules"])), [[_directive_loading, formLoading.value]])]),
        _: 1
      }, 8, ["title", "modelValue"]);
    };
  }
});